import Button from '@mui/material/Button'
import React from 'react'
import { getButtonTestId } from './getButtonTestId'

/** @notExported */
interface CaleoYellowButtonProps {
  /** Click action. */
  clickAction: () => void
  /** Whether the button is valid. */
  valid: boolean
  /** Button label. */
  label: React.ReactNode
  /** Test id of the button. */
  testId?: string
}

/**
 * Caleo yellow button.
 *
 * @returns Caleo yellow button component.
 * @category Buttons
 */
const CaleoYellowButton: React.FC<CaleoYellowButtonProps> = ({ clickAction, valid, label, testId }) => {
  const resolvedTestId = getButtonTestId({ fallback: 'button-yellow', label, testId })

  return (
    <Button
      id="search"
      data-testid={resolvedTestId}
      type="button"
      variant="contained"
      disabled={!valid}
      onClick={() => clickAction()}
      color="warning"
    >
      {label}
    </Button>
  )
}

export default CaleoYellowButton
